var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-container",class:_vm.className},[(_vm.width === 'default')?_c('div',{staticClass:"container"},[_vm._t("default")],2):_c('div',{staticClass:"container"},[_vm._t("outer-before"),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._t("default")],2),_vm._v(" "),_vm._t("outer-after")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }